import React, { useEffect, useState } from 'react';

import { Box, Button, Grid, Typography, TextField } from '@mui/material';

import { ticketTypoTitle } from '../../shared/commonStyle';

const RepairTicketProcess = (props) => {
  const handleOpen = props.handleOpen;
  const handleOpenView = props.handleOpenView;
  const cancelReason = props.cancelReason;
  const [cancelReasonVal, setCancelReasonVal] = useState(
    props.ticketData.cancel_reason !== null || undefined
      ? props.ticketData.cancel_reason
      : null

    // props.status !== 'canceled' ? null : props.cancelReason
  );

  const onSave = props.onSave;
  const cancelSave = props.cancelSave;

  // useEffect(() => {
  //   let cancelText = props.ticketData.cancel_reason;
  //   // === null
  //   //   ? ''
  //   //   : props.ticketData.cancel_reason;
  //   setCancelReasonVal(cancelText);
  // });

  const [cancelButton, setCancelButton] = useState(true);
  useEffect(() => {
    let cancelState = cancelReasonVal;
    if (cancelState === null || cancelState.trim() === '') {
      setCancelButton(false);
    } else {
      if (cancelState.length >= 5 && props.ticketStatus !== 'new') {
        setCancelButton(true);
      } else {
        setCancelButton(false);
      }
    }
  }, [cancelReasonVal]);

  const handleChange = (event) => {
    cancelReason(event.target.value);
    setCancelReasonVal(event.target.value);
  };

  return (
    <Box
      name='ticketActions'
      style={{
        // minHeight: '20vh',
        maxWidth: '100%',
        textAlign: 'right',
        borderRadius: '5px',
        padding: '0 15px 15px 15px',
        margin: '10 0',
      }}
    >
      <Button
        onClick={() => onSave()}
        variant='contained'
        color='error'
        style={{ margin: '15px 5px', fontWeight: '700' }}
        disabled={
          cancelButton ? false : true

          // cancelReasonVal === '' || null
          //   ? // || cancelReasonVal.length < 5
          //     false
          //   : cancelReasonVal.length < 5
          //   ? true
          //   : false
        }
      >
        Cancel Ticket
      </Button>

      <Button
        variant='contained'
        color='success'
        style={{ margin: '15px 5px', fontWeight: '700' }}
        onClick={() => handleOpenView()}
      >
        View
      </Button>
      <Button
        variant='contained'
        color='success'
        style={{ margin: '15px 5px', fontWeight: '700' }}
        onClick={() => handleOpen()}
      >
        Upload
      </Button>
      <Button
        disabled={cancelButton ? true : false}
        onClick={() => onSave()}
        variant='contained'
        color='success'
        style={{ margin: '15px 5px', fontWeight: '700' }}
      >
        Save
      </Button>
      <Button
        variant='contained'
        color='success'
        style={{ margin: '15px 5px', fontWeight: '700' }}
        onClick={() => cancelSave()}
      >
        Back
      </Button>
      <Grid
        container
        xs={12}
        md={12}
        flexDirection='row'
        rowGap={1}
        columnGap={1}
        alignContent='flex-start'
      >
        <Grid item xs={12} lg={7.8}>
          <Typography style={ticketTypoTitle}>
            Reason For Canceling Ticket:
          </Typography>
        </Grid>
        <Grid item xs={12} lg={4}>
          <TextField
            /**/
            disabled={
              props.ticketStatus !== 'logged' &&
              props.ticketStatus !== 'assigned' &&
              props.ticketStatus !== 'upliftment'
            }
            placeholder='Provide a reason to enable cancel...'
            name='cancelInput'
            id='cancelInput'
            value={cancelReasonVal}
            onChange={handleChange}
            size='small'
            sx={{
              width: '100%',
              background: '#ffffff',
              padding: 0,
            }}
            required
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default RepairTicketProcess;
